// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mg-table-leads tr > td > span {
  word-break: break-all; }
`, "",{"version":3,"sources":["webpack://./src/components/no/motorgruppen/leads/Leads.scss"],"names":[],"mappings":"AAIA;EACE,qBAAqB,EAAA","sourcesContent":[".campaigns {\n\t\n}\n\n.mg-table-leads tr > td > span {\n  word-break: break-all;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
